export const PRIMARY_COLOR = "#1C1C1C";
export const SECONDARY_COLOR = "#F7F5F0";
export const ACCENT_1_COLOR = "#8B1E21";
export const ACCENT_2_COLOR = "#9A8456";
export const ACCENT_3_COLOR = "#765946";